module.exports = __webpack_public_path__ + "img/zxsqurer.4ea41c02.png";